<div *ngIf="initFlaq"
  class="flex flex-wrap align-items-center justify-content-center card-container blue-container race-auth">
  
  <button pButton *ngIf="user" (click)="logout()">{{ settingService.translate[settingService.selectedLang]['exit']
    }}</button>
  <form>
    <div *ngIf="!user">
      <!-- Кнопка авторизации через Госуслуги (ЕСИА), только для российских номеров -->
      <!-- <div class="col-12 sm:col-12 lg:col-12" *ngIf="countryCode === 'ru'">
        <button
          type="button"
          (click)="loginViaEsia()"
          class="esia-btn"
        >
          <span class="esia-btn__icon">&#11088;</span>
          <span class="esia-btn__text">Войти через Госуслуги</span>
        </button>
      </div> -->
      <!-- <div class="col-12"></div> -->
      <!-- Ввод номер телефона -->
      <div class="col-12 sm:col-12 lg:col-12 phone" [ngClass]="{ loading: loading }">
        <span class="p-float-label">
          <app-intl-phone-input
            [cssClass]="'full-width'"
            [selectedCountryISO]="'ru'"
            [maxLength]="'20'"
            [placeholder]="'Введите номер телефона'"
            [enableAutoPlaceholder]="true"
            [value]="phone"
            (valueChange)="onPhoneNumberChange($event)"
            (countryChange)="onCountryChange($event)"
            (intlTelInputObject)="telInputObject($event)"
          ></app-intl-phone-input>
          <label for="inputtext">{{ settingService.translate[settingService.selectedLang]['phone'] }}</label>
        </span>
        <p-progressBar *ngIf="loading" mode="indeterminate" [style]="{ height: '6px' }"></p-progressBar>
      </div>
      <div *ngIf="notRussia && reqConfirm" class="col-12 sm:col-12 lg:col-12 phone" [ngClass]="{ loading: loading }">
        <span class="p-float-label">
          <input id="inputtext" type="email" [(ngModel)]="email" required pattern="^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$" [ngModelOptions]="{ standalone: true }" style="width: 100%" pInputText />
          <label for="inputtext">{{ settingService.translate[settingService.selectedLang]['email'] }}</label>
        </span>
      </div>
      <!-- Сообщение и кнопки при входе по звонку на номер стороннего оператора -->
      <div *ngIf="textCallNumber">
        <button style="width: 100%; margin-bottom: 0.5rem;" pButton type="button" (click)="cancelPincode()"
          [label]="settingService.translate[settingService.selectedLang]['cancel']"
          class="ui-button-secondary"></button>
        <p-messages severity="info">
          <ng-template pTemplate>
            <div [innerHTML]="textCallNumber"></div>
          </ng-template>
        </p-messages>
      </div>
      <!-- Остальные способы авторизации -->
      <div *ngIf="!textCallNumber">
        <!-- Ввод пароля - показывается только если такой пользователь (по номеру телефона) есть в базе -->
        <div class="col-12 sm:col-12 lg:col-12" *ngIf="!reqConfirm && !showDialogForEnterPhonePincode">
          <span class="p-float-label">
            <input type="password" style="width: 100%" pInputText [disabled]="reqConfirm || authService.authProcess"
              (keypress)="eventHandler($event)" [(ngModel)]="pass" [ngModelOptions]="{ standalone: true }" />
            <label for="inputtext">{{ settingService.translate[settingService.selectedLang][remainderTextInput]
              }}</label>
          </span>
        </div>
        <!-- Кнопка войти по паролю - показывается только если такой пользователь (по номеру телефона) есть в базе -->
        <div class="col-12 sm:col-12 lg:col-12" *ngIf="!reqConfirm && !showDialogForEnterPhonePincode">
          <button style="width: 100%" pButton type="button" (click)="authUser(true)" [disabled]="!pass || !phone"
            [label]="settingService.translate[settingService.selectedLang]['enter']"
            class="ui-button-secondary"></button>
        </div>
<!-- Авторизация по звонку на номер стороннего оператора (sms.ru callcheck) -->
        <div class="col-12 sm:col-12 lg:col-12" *ngIf="countryCode === 'ru' && !reqConfirm && !showDialogForEnterPhonePincode">
          <div class="p-inputgroup">
            <button
              style="width: 100%"
              pButton
              type="button"
              (click)="showCallCheckInit()"
              [label]="settingService.translate[settingService.selectedLang]['getCallInit']"
              [disabled]="!phone"
              class="ui-button-secondary"
            ></button>
            <button pButton type="button" (click)="showCallCheckInfo()" icon="pi pi-info-circle" class="ui-button-secondary"></button>
          </div>
        </div>
        <!-- Поле ввода пинкода при авторизации по пинкоду (из смс, или входящего звонка) -->
        <div class="col-12 sm:col-12 lg:col-12" *ngIf="showDialogForEnterPhonePincode">
          <span class="p-float-label">
            <input type="password" style="width: 100%" pInputText [(ngModel)]="pass"
              [ngModelOptions]="{ standalone: true }" (keyup)="onPinKeyUp()" />
            <label for="inputtext">{{ settingService.translate[settingService.selectedLang]['pincode'] }}</label>
          </span>
        </div>
        <!-- Кнопка Отмена пинкода при авторизации по пинкоду (из смс, или входящего звонка) -->
        <div class="col-12 sm:col-12 lg:col-12" *ngIf="showDialogForEnterPhonePincode">
          <button style="width: 100%" pButton type="button" (click)="cancelPincode()"
            [label]="settingService.translate[settingService.selectedLang]['cancel']"
            class="ui-button-secondary"></button>
        </div>
        <!-- Кнопка входа по пинкоду при авторизации по пинкоду (из смс, или входящего звонка) -->
        <div class="col-12 sm:col-12 lg:col-12" *ngIf="showDialogForEnterPhonePincode">
          <button style="width: 100%" pButton type="button" (click)="authUser()" [disabled]="!pass"
            [label]="notRussia ? settingService.translate[settingService.selectedLang]['getPincodeEmail'] : settingService.translate[settingService.selectedLang]['getPincode']"
            class="ui-button-secondary"></button>
        </div>
        <!-- Кнопка отправки пинкода в смс при авторизации по пинкоду, только для российских номеров телефонов -->
        <div class="col-12 sm:col-12 lg:col-12"
          *ngIf="countryCode === 'ru' && reqConfirm && !showDialogForEnterPhonePincode">
          <div class="p-inputgroup">
            <button style="width: 100%" pButton type="button" (click)="sendPin()"
              [label]="settingService.translate[settingService.selectedLang]['getPincode']"
              class="ui-button-secondary"></button>
            <button pButton type="button" (click)="showPassInfo()" icon="pi pi-info-circle"
              class="ui-button-secondary"></button>
          </div>
        </div>
        <!-- Кнопка отправки пароля в смс, только для российских номеров телефонов -->
        <div class="col-12 sm:col-12 lg:col-12"
          *ngIf="countryCode === 'ru' && !reqConfirm && !showDialogForEnterPhonePincode">
          <div class="p-inputgroup">
            <button style="width: 100%" pButton type="button" [disabled]="!phone" (click)="sendPass()"
              [label]="settingService.translate[settingService.selectedLang]['getPassword']"
              class="ui-button-secondary"></button>
            <button pButton type="button" (click)="showPassInfo()" icon="pi pi-info-circle"
              class="ui-button-secondary"></button>
          </div>
        </div>
        <div class="col-12 sm:col-12 lg:col-12"
          *ngIf="countryCode !== 'ru' && !reqConfirm && !showDialogForEnterPhonePincode">
          <div class="p-inputgroup">
            <button style="width: 100%" pButton type="button" [disabled]="!phone" (click)="sendPassToEmail()"
              [label]="settingService.translate[settingService.selectedLang]['getPassword']"
              class="ui-button-secondary"></button>
            <button pButton type="button" (click)="showPassInfo()" icon="pi pi-info-circle"
              class="ui-button-secondary"></button>
          </div>
        </div>
        <!-- Кнопка отправки пинкода на email для нероссийских номеров -->
        <div class="col-12 sm:col-12 lg:col-12" *ngIf="!showDialogForEnterPhonePincode && reqConfirm && notRussia">
          <div class="p-inputgroup">
            <button style="width: 100%" pButton type="button" [disabled]="!email || !isValidEmail(email)" (click)="initEmail()"
              [label]="settingService.translate[settingService.selectedLang]['sendToEmail']"
              class="ui-button-secondary"></button>
            <button pButton type="button" (click)="showInitInfo()" icon="pi pi-info-circle"
              class="ui-button-secondary"></button>
          </div>
        </div>
      </div>
    </div>
  </form>
</div>